import {createContext} from 'react';

const PositionContextMobile = createContext(null);

export default PositionContextMobile;
